import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * primary / outline: for light (cream) sections.
   * heroPrimary / heroOutline: for the dark blue hero.
   */
  variant?: 'primary' | 'outline' | 'heroPrimary' | 'heroOutline';
  children: React.ReactNode;
  className?: string;
  href?: string;
}
const BASE = 'inline-flex items-center justify-center px-8 py-3 rounded-full font-medium text-lg tracking-wide transition-colors duration-200 ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2';
const VARIANTS = {
  primary: 'bg-bronze-500 text-white hover:bg-bronze-600 focus-visible:ring-bronze-400 focus-visible:ring-offset-paper',
  outline: 'bg-transparent border border-bronze-400 text-bronze-600 hover:bg-bronze-400/10 hover:text-bronze-600 focus-visible:ring-bronze-400 focus-visible:ring-offset-paper',
  heroPrimary: 'bg-gold-400 text-ink-900 hover:bg-gold-500 focus-visible:ring-gold-400 focus-visible:ring-offset-navy',
  heroOutline: 'bg-transparent border-2 border-gold-400 text-gold-400 hover:border-gold-300 hover:text-gold-300 hover:bg-gold-400/10 focus-visible:ring-gold-400 focus-visible:ring-offset-navy'
};
export function Button({
  variant = 'primary',
  children,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const combinedClassName = `${BASE} ${VARIANTS[variant]} ${className}`;
  if (href) {
    return <motion.a href={href} className={combinedClassName} whileTap={{
      scale: 0.98
    }} data-id="element-209" data-mp="12l8slovjtb7t">
        {children}
      </motion.a>;
  }
  return <motion.button className={combinedClassName} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-210" data-mp="1ccvdkcxouonr">
      {children}
    </motion.button>;
}